export const sublinksLoaded = messageParts => {
	const subLinks = JSON.parse( messageParts[ 1 ] );
	const links = document.querySelectorAll( '[data-sub-link]' );
	links.forEach( function ( link ) {
		const linkName = link.dataset.subLink;
		if ( linkName && subLinks.hasOwnProperty( linkName ) && subLinks[ linkName ].length ) {
			link.href = subLinks[ linkName ];
			const eventType = link.dataset.eventType ? link.dataset.eventType : 'link_click';

			const eventObjectText = link.dataset.eventObjectText
				? link.dataset.eventObjectText
				: link.innerText;

			const eventLabel = link.dataset.label ? link.dataset.label : linkName;

			const dataLayerEvent = {
				event: eventType,
				event_action: 'click',
				event_type: 'subscribe',
				event_object_name: 'subscribe button',
				button_text: eventObjectText,
				event_label: eventLabel,
				piano_label: eventLabel,
				service_platform: 'piano',
			};

			link.addEventListener( 'click', () => {
				dataLayer.push( dataLayerEvent );
			} );
		}
	} );
};

export default sublinksLoaded;
